<div class="md:px-4 py-4 grid grid-cols-2 gap-3">
  @for (item of itemsWithIcons(); track item.name) {
    <div class="flex items-center gap-3 p-2 bg-gray-98 border border-gray-90 rounded-lg min-w-0">
      @if (isFuelItem(item)) {
        <img class="inline py-1 shrink-0" [src]="item.icon" alt="" />
      } @else {
        <div class="bg-bg-tertiary p-2 rounded-lg shrink-0">
          <lds-icon [name]="item.icon" [size]="Size.SM" class="text-primary-40 text-xl" />
        </div>
      }
      <span class="text-body-2-desktop font-medium min-w-0 break-words">{{ item.displayName }}</span>
    </div>
  }
</div>
